import React from 'react';
import { Drawer } from 'vaul';
import './index.scss';

interface TermsDrawerProps {
  href: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
}

const withMobileAppParam = (href: string): string => {
  const url = new URL(href);
  url.searchParams.set('mobileapp', 'true');
  return url.toString();
};

const TermsDrawer = ({ href, open, onOpenChange, title }: TermsDrawerProps) => {
  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange} snapPoints={[0.5, 1]}>
      <Drawer.Portal>
        <Drawer.Overlay className="terms-drawer-overlay" />
        <Drawer.Content className="terms-drawer-content">
          <Drawer.Handle />
          <div className="terms-drawer-header">
            <Drawer.Title className="terms-drawer-title">{title}</Drawer.Title>
            <Drawer.Close className="terms-drawer-close" aria-label="Close">
              &times;
            </Drawer.Close>
          </div>
          <iframe className="terms-drawer-iframe" src={withMobileAppParam(href)} title={title} />
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};

export default TermsDrawer;
